enum STATUS {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  DELETE = 'deleted',
}

export default STATUS;
